import { api } from "api/api";
import { AxiosError } from "axios";
import AuditoriaClassificacaoNota from "model/auditoria5s/auditoria/AuditoriaClassificacaoNota";
import ImagemFixa from "model/ImagemFixa";

export default class AuditoriaClassificacaoNotaService {

    buscar() {
        return new Promise<Array<AuditoriaClassificacaoNota>>((resolve, reject): void => {
            let url = `/auditoriaClassificacaoNota/buscar`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    alterar(classificoes: AuditoriaClassificacaoNota[]) {
        return new Promise<Array<AuditoriaClassificacaoNota>>((resolve, reject): void => {
            let url = `/auditoriaClassificacaoNota/alterar`;
            api
                .put(url, classificoes)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    buscarImagensDisponiveis() {
        return new Promise<Array<ImagemFixa>>((resolve, reject): void => {
            let url = `/auditoriaClassificacaoNota/imagensDisponiveis`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}